import { FlowContext } from 'src/lib/flow';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { isAgent, isWorkingWithHomebuilder } from 'src/lib/flow/pageHelpers';

export function isEnabled({
  answers,
  inputContext: { channel, homebuilderIdentifier },
  featureFlags,
}: FlowContext) {
  return (
    !isAgent(answers, channel) &&
    !isWorkingWithHomebuilder(answers, homebuilderIdentifier) &&
    featureFlags.isInListWithCertaintyTreatment
  );
}

const sellYourWayPage: FlowPage = {
  slug: () => 'sell-your-way',
  title: () => 'More ways to sell with Opendoor',
  subtitle: () =>
    'Now we can help you list your home for more on the market. We’ll show you a range that includes both our cash offer and potential listing price.',
  isEnabled,
  autoAdvance: () => false,
  questions: () => [
    {
      key: 'sell_your_way',
      type: 'element',
      component: 'sell_your_way',
    },
  ],
};

export default sellYourWayPage;
